import { PasswordRule } from './PasswordRule';

export class MinLength extends PasswordRule {

    name = 'MinLength';
    errorMessage = 'minimum_length_not_met';
    minLength = 0;

    constructor(minLength) {
        super();
        this.minLength = minLength;
    }

    passes(input) {
        return input.length >= this.minLength;
    }

    getAttributes() {
        return {
            minLength: this.minLength
        };
    }
}
